import { City } from './types';

export const smallCities: City[] = [
  { name: "Wheaton", population: 53648, rank: 26 },
  { name: "Hoffman Estates", population: 51895, rank: 27 },
  { name: "Oak Park", population: 51878, rank: 28 },
  { name: "Downers Grove", population: 49504, rank: 29 },
  { name: "Elmhurst", population: 47260, rank: 30 },
  { name: "Glenview", population: 47258, rank: 31 },
  { name: "DeKalb", population: 43849, rank: 32 },
  { name: "Lombard", population: 43395, rank: 33 },
  { name: "Belleville", population: 41290, rank: 34 },
  { name: "Moline", population: 41250, rank: 35 },
  { name: "Buffalo Grove", population: 41174, rank: 36 },
  { name: "Bartlett", population: 41085, rank: 37 },
  { name: "Crystal Lake", population: 40269, rank: 38 },
  { name: "Carol Stream", population: 39860, rank: 39 },
  { name: "Quincy", population: 39829, rank: 40 }
];